import React, { Component } from 'react';

export default class DetalheConfiguracaoBilhete extends Component {

    exibeRegraW2i(configuracaoBilhete) {        
        return (
            <table className="table table-sm table-bordered">
                <thead>
                    <tr style={{backgroundColor: '#ffffff66'}}>
                        <td className='text-center'><strong>ID</strong></td>
                        <td className='text-center'><strong>Orgão Regulador</strong></td>
                        <td className='text-center'><strong>Descricao</strong></td>
                        <td className='text-center'><strong>Ativo</strong></td>
                        <td className='text-center'><strong>Ações</strong></td>
                    </tr>
                </thead>
                <tbody>
                {configuracaoBilhete.map((config, index) => (
                    <tr key={index}>
                        <td className='text-center'>{config.id}</td>
                        <td className='text-center'>{config.orgaoRegulador.valor}</td>
                        <td className='text-center'>{config.descricao}</td>
                        <td className='text-center'>{config.ativo ? 'Sim' : 'Não'}</td>
                        <td className='text-center'>
                            <div className="acoes">
                                <div className="botoes">
                                    <button type="button" className="btn btn-editar ml-2"
                                            data-toggle="modal"
                                            data-target="#modalCadastrarConfiguracaoBilhete"
                                            onClick={() => this.props.selecionarBilhete(config)}
                                            >
                                    <i className="material-icons nav-icon">&#xe150;</i>
                                    </button>              
                                </div>
                            </div>
                        </td>
                    </tr>                    
                ))}
                </tbody>
            </table>
        )
    }

    exibeRegraCuritiba(configuracaoBilhete) {        
        return (
            <table className="table table-sm table-bordered">
                 <thead>
                    <tr style={{backgroundColor: '#ffffff66'}}>
                        <td className='text-center'><strong>ID</strong></td>
                        <td className='text-center'><strong>Código Empresa</strong></td>
                        <td className='text-center'><strong>Descricao</strong></td>
                        <td className='text-center'><strong>Sequencial</strong></td>
                        <td className='text-center'><strong>Ações</strong></td>
                    </tr>
                </thead>
                <tbody>
                {configuracaoBilhete.map((config, index) => (
                    <tr key={index}>
                        <td className='text-center'>{config.id}</td>
                        <td className='text-center'>{config.codigoEmpresa}</td>
                        <td className='text-center'>{config.descricao}</td>
                        <td className='text-center'>{config.sequencial}</td>
                        <td className='text-center'>
                            <div className="acoes">
                                <div className="botoes">
                                    <button type="button" className="btn btn-editar ml-2"
                                            data-toggle="modal"
                                            data-target="#modalCadastrarConfiguracaoBilhete"
                                            onClick={() => this.props.selecionarBilhete(config)}
                                            >
                                    <i className="material-icons nav-icon">&#xe150;</i>
                                    </button>              
                                </div>
                            </div>
                        </td>
                    </tr>                    
                ))}
                </tbody>
            </table>
        )
    }

    render() {
        if (!this.props.configuracao.exibirDetalhe) {
            return ''
        }
        return (
            <div className="card-body cinza-zebrado table-responsive-sm">
                {this.props.configuracao.regra.chave == 'REGRA_CURITIBA' ? this.exibeRegraCuritiba(this.props.configuracao.configuracaoBilhete) : this.exibeRegraW2i(this.props.configuracao.configuracaoBilhete)}
            </div>
        )
    }

}